// Serbian number and currency formatting utilities

export const formatNumberSR = (
  value: number,
  options?: Intl.NumberFormatOptions
) => new Intl.NumberFormat('sr-RS', options).format(value);

export const formatCurrencySR = (
  value: number,
  currency: string = 'RSD',
  options?: Intl.NumberFormatOptions
) =>
  new Intl.NumberFormat('sr-RS', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  })
    .format(value)
    .replace(currency, currency); // Ensures 'RSD' is used, not 'din.' 